import commonService from "./common-service";

class SSRSService {
  async generateSsrsFile(params, fileName) {
    try {
     await commonService.downloadFromSSRS(
        "SSRS" ,
        params,
        fileName
      );
     
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getSsrsReports(type){
    try{
      const response = await commonService.getFromServer('SSRS?type='+ type, {});

      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch(e){
      throw new Error("Error loading carriers");
    }
  }

  async getSsrsTypes(){
    try{
      const response = await commonService.getFromServer('SSRS/Types', {});

      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch(e){
      throw new Error("Error loading carriers");
    }
  }
}
export default new SSRSService();
